// Copyright (c) 2019 Comsearch, Inc., All rights reserved

import React, { Suspense } from 'react'
import { AuthRoute } from 'components/Auth'
import { RoutesWrapper } from './styles'

import {
  Route,
  Switch,
} from 'react-router-dom'

import {
  ROLES_PATH_DATABASE,
  ROLES_PROTECTION,
  ROLES_PROJECT_TRACKER,
  ROLES_PRICING_MANAGEMENT,
  ROLES_SUAS,
} from 'constants/userGroups'

import {
  HomePage,
  LoadingIcon,
  Navigation,
} from 'components'

const Protection = React.lazy(() => import('components/Protection'))
const PageNotFound = React.lazy(() => import('components/PageNotFound'))
const ProjectTracker = React.lazy(() => import('components/ProjectTracker'))
const PathDatabase = React.lazy(() => import('components/PathDatabase'))
const PricingManagement = React.lazy(() => import('components/PricingManagement'))
const DataProducts = React.lazy(() => import('components/DataProducts'))
const RfDroneServices = React.lazy(() => import('components/RfDroneServices'))
const PathDatabaseEnhancement = React.lazy(() => import('components/PathDatabaseEnhancement'))

const Routes = () => (
  <RoutesWrapper>
    <Navigation />
    <div className={'page-wrapper -s'}>
      <Suspense
        fallback={(
          <LoadingIcon isLoading={true} />
        )}>
        <Switch>
          <Route
            component={HomePage}
            exact={true}
            path={'/'} />
          <AuthRoute
            component={ProjectTracker}
            exact={true}
            requiredGroups={ROLES_PROJECT_TRACKER}
            path={'/project-tracker'} />
          <AuthRoute
            component={Protection}
            exact={true}
            requiredGroups={ROLES_PROTECTION}
            path={'/protection'} />
          <AuthRoute
            component={PathDatabase}
            exact={true}
            requiredGroups={ROLES_PATH_DATABASE}
            path={'/path-database'} />
          <AuthRoute
            component={DataProducts}
            path={'/data-products'} />
          <AuthRoute
            component={RfDroneServices}
            requiredGroups={ROLES_SUAS}
            path={'/rf-drone-services'} />
          <AuthRoute
            path='/path-database/path-details/:pathId'
            component={PathDatabaseEnhancement} />
          <AuthRoute
            component={PageNotFound}
            path={'*'} />
        </Switch>
      </Suspense>
    </div>
  </RoutesWrapper>
)

export default Routes
